import ApiService from "@/services/apiService";
import RegistrierungForm from "./RegistrierungForm.vue";
import { createApp } from "vue";

let registrierungContainer = document.getElementById("registrierung-form");

if(registrierungContainer) {
    const app= createApp(RegistrierungForm, { container: registrierungContainer });
    ApiService.create();
    app.mount(registrierungContainer);
}

